import comp from "./LearningGoalsNestedView";
export default comp;
